import { Card, CardActionArea, CardContent, Grid } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { Link } from "react-router-dom";
import PeopleIcon from "@mui/icons-material/People";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

const sections = [
    {
        name: "Users",
        description: "Look up users, institutions, and portfolios",
        to: "/users",
        icon: <PeopleIcon fontSize="large" color="primary" />,
    },
    {
        name: "Assets",
        description: "Search, inspect, and add tradable assets",
        to: "/assets",
        icon: <AccountBalanceIcon fontSize="large" color="primary" />,
    },
];

export default function HomePage () {
    return (
        <Box sx={{ maxWidth: '64rem', marginX: 'auto', paddingY: '2rem', paddingX: '1rem' }}>
            <Typography variant="h4" gutterBottom>
                Welcome to Jedi Portal
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ marginBottom: '2rem' }}>
                AutoPilot's internal admin console. Jump into a section below, or use the sidebar to navigate.
            </Typography>
            <Grid container spacing={2}>
                {sections.map((section) => (
                    <Grid item xs={12} sm={6} key={section.to}>
                        <Card variant="outlined" sx={{ height: '100%' }}>
                            <CardActionArea
                                component={Link}
                                to={section.to}
                                sx={{ height: '100%', alignItems: 'flex-start' }}
                            >
                                <CardContent>
                                    {section.icon}
                                    <Typography variant="h6" sx={{ marginTop: '.5rem' }}>
                                        {section.name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {section.description}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}
